import { SxmLogoIcon } from '@/assets/icons/SxmLogoIcon';
import { SxmLogoLetterIcon } from '@/assets/icons/SxmLogoLetterIcon';
import { Link } from '@/ui-components/atoms/Link/Link';

interface RenderLogoProps {
    logo?: string;
    logoUrl?: string;
    headerId?: string;
    styles: Record<string, string>;
}

export function RenderLogo({ headerId, logo, logoUrl, styles }: RenderLogoProps) {
    const staticHeader = headerId === 'static';
    const logoIcon = logo ? <img src={logo} alt="" /> : <SxmLogoIcon />;
    const logoIconSmall = logo ? <img src={logo} alt="" /> : <SxmLogoLetterIcon />;

    if (logoUrl && !staticHeader) {
        return (
            <>
                <Link className={styles.logoWrapper} href={logoUrl} aria-label="SiriusXM">
                    {logoIcon}
                </Link>
                <Link className={styles.logoSmallWrapper} href={logoUrl} aria-label="SiriusXM">
                    {logoIconSmall}
                </Link>
            </>
        );
    } else {
        return (
            <>
                <span className={styles.logoWrapper}>{logoIcon}</span>
                <span className={styles.logoSmallWrapper}>{logoIcon}</span>
            </>
        );
    }
}
